import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { FlagBadge } from './FlagBadge';
import { _js } from '@ifixit/localize';

export function TimeTakenBadge({
   timeRequired,
   className,
}: {
   timeRequired: string;
   className?: string;
}) {
   return (
      <Tooltip>
         <TooltipTrigger asChild>
            <FlagBadge
               icon="clock"
               iconStyle="solid"
               badgeClass="bg-gray-100 border-gray-300 text-gray-700"
               iconClass="text-gray-500"
               className={className}
            >
               {timeRequired}
            </FlagBadge>
         </TooltipTrigger>
         <TooltipContent className="text-sm">
            {_js(
               'Rough estimate of how long this takes. (Use this to plan your day, not to feel judged.)'
            )}
         </TooltipContent>
      </Tooltip>
   );
}
